<div class="btn-float">
  <i class="bi bi-file-earmark-plus-fill"></i>
</div>
<div class="dashboard-card list-card">
  <div class="widget-header">
    <h5>
      Modules Master List
    </h5>
    <!-- <select class="form-select w-50" [(ngModel)]="inst_id">
				<option value="0">
						Select Institute
				</option>
				@for(inst of institutes; track $index) {
						<option value="{{inst.id}}">{{inst.inst_name}}</option>
				}
		</select> -->
    <button class="btn btn-sm btn-light py-0" data-bs-toggle="modal" data-bs-target="#frmBackdrop" (click)="newClick()">
      +Add New
    </button>
  </div>

  <div class="w-100">
    <table id="orgTable" class="table table-striped w-100">
      <thead>
        <tr>
          <th>#</th>
          <th>Name/Desc.</th>
          <th width="250">Prices</th>
          <th>Active?</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        @for(data of allData; track $index; let idx = $index;) {
        <tr>
          <td>{{idx+1}}.</td>
          <td><b>{{data.m_name}}</b> ({{data.code.toUpperCase()}})<br>{{data.description}}</td>
          <td>
            <div class="row w-100 text-center">
              <div class="col-auto"><small><b>M</b></small><br>{{data.m_price}}</div>
              <div class="col-auto"><small><b>Q</b></small><br>{{data.q_price}}</div>
              <div class="col-auto"><small><b>H</b></small><br>{{data.h_price}}</div>
              <div class="col-auto"><small><b>A</b></small><br>{{data.a_price}}</div>
            </div>
          </td>
          <td>{{data.is_active ? 'Yes' : 'No'}}</td>
          <td>
            <div class="d-flex gap-2">
              <span style="cursor: pointer;" data-bs-toggle="modal" data-bs-target="#frmBackdrop"
                (click)="editClick(data)" title="Modify">
                <i class="bi bi-pencil-square text-success"></i>
              </span>
              <span style="cursor: pointer;" (click)="deleteClick(data.id)" title="Delete">
                <i class="bi bi-trash3-fill text-danger"></i>
              </span>
            </div>
          </td>
        </tr>
        }
      </tbody>
    </table>

    <div class="text-danger" align="center" *ngIf="allData && !allData.length && !loading">
      <i class="bi bi-x-circle"></i> No data available.
      <span (click)="ngOnInit()" style="cursor: pointer;"><u>Refresh Data</u></span>
    </div>
  </div>
</div>

<!-- <div class="offcanvas offcanvas-end" tabindex="-1" id="offcanvasRight" aria-labelledby="offcanvasRightLabel"
	style="width: 500px;">
	<div class="offcanvas-header">
		<h5 class="offcanvas-title" id="offcanvasRightLabel">Modules Master</h5>
		<button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
	</div>
	<div class="offcanvas-body">
//
	</div>
</div> -->

<div class="modal fade" id="frmBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
  aria-labelledby="frmBackdropLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="frmBackdropLabel">Modules Master Form</h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body py-3">

        <div class="row g-3">
          <!-- Active -->
          <div class="col-md-12">
            <label class="form-label fw-semibold">
              Available Modules <span class="text-danger">*</span>
            </label>

            <select class="form-select" name="defaultMOD" (change)="getCodeName($event);">
              <option ngValue="">Select</option>
              @for(mm of defaultMOD; track mm.for_module; let idx = $index;) {
                <option [value]="mm.optClick">{{mm.title}}</option>
              }
            </select>
          </div>

          <!-- Module Code -->
          <div class="col-md-4" [hidden]="true">
            <label class="form-label fw-semibold">
              Module Code
              <span class="text-danger">*</span>
            </label>

            <input type="text" class="form-control" name="code" [(ngModel)]="frmData.code" #code="ngModel" required
              maxlength="20" placeholder="Enter code">

            <div class="text-danger small mt-1" *ngIf="code.invalid && code.touched">
              Module Code is required.
            </div>
          </div>

          <!-- Module Name -->
          <div class="col-md-8" [hidden]="true">
            <label class="form-label fw-semibold">
              Module Name
              <span class="text-danger">*</span>
            </label>

            <input type="text" class="form-control" name="m_name" [(ngModel)]="frmData.m_name" #m_name="ngModel" required
              maxlength="100" placeholder="Enter module name">

            <div class="text-danger small mt-1" *ngIf="m_name.invalid && m_name.touched">
              Module Name is required.
            </div>
          </div>

          <!-- Description -->
          <div class="col-12">
            <label class="form-label fw-semibold">
              Description
            </label>

            <textarea rows="3" class="form-control" name="description" [(ngModel)]="frmData.description"
              placeholder="Enter module description">
            </textarea>
          </div>

          <!-- Price -->
          <div class="col-md-12">
            <label class="form-label fw-semibold">
              Price: [M-Q-SA-An]
            </label>

            <div class="input-group">
              <span class="input-group-text">₹</span>

              <input type="text" class="form-control" name="price1" [(ngModel)]="frmData.m_price" #prices="ngModel" required
                min="0" placeholder="0.00">
              <input type="text" class="form-control" name="price2" [(ngModel)]="frmData.q_price" #prices="ngModel" required
                min="0" placeholder="0.00">
              <input type="text" class="form-control" name="price3" [(ngModel)]="frmData.h_price" #prices="ngModel" required
                min="0" placeholder="0.00">
              <input type="text" class="form-control" name="price4" [(ngModel)]="frmData.a_price" #prices="ngModel" required
                min="0" placeholder="0.00">
            </div>

            <div class="text-danger small mt-1" *ngIf="prices.invalid && prices.touched">
              Valid price is required.
            </div>
          </div>

          <!-- Sort Number -->
          <div class="col-md-3">
            <label class="form-label fw-semibold">
              Sort
              <span class="text-danger">*</span>
            </label>

            <input type="number" class="form-control" name="sort_no" [(ngModel)]="frmData.sort_no" #sort_no="ngModel" required
              min="1" placeholder="1">

            <div class="text-danger small mt-1" *ngIf="sort_no.invalid && sort_no.touched">
              Sort Number is required.
            </div>
          </div>

          <!-- Active -->
          <div class="col-md-3">
            <label class="form-label fw-semibold">
              Active
              <span class="text-danger">*</span>
            </label>

            <select class="form-select" name="is_active" [(ngModel)]="frmData.is_active" #is_active="ngModel" required>
              <option ngValue="">Select Status</option>
              <option value="true">Yes</option>
              <option value="false">No</option>
            </select>

            <div class="text-danger small mt-1" *ngIf="is_active.invalid && is_active.touched">
              Please select status.
            </div>
          </div>
        </div>

      </div>
      <div class="modal-footer">
        <button type="button" class="col-2 btn btn-sm btn-secondary" data-bs-dismiss="modal">Cancel</button>
        <button type="button" class="col-2 btn btn-sm btn-primary" data-bs-dismiss="modal"
          (click)="isEdit ? doUpdate() : doSave();">
          {{isEdit ? 'Update' : 'Save'}}
        </button>
      </div>
    </div>
  </div>
</div>
